import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTUREINVOICE,
    RETRIEVE_ARCHITECTUREINVOICE,
    RETRIEVESINGLE_ARCHITECTUREINVOICE,
    UPDATE_ARCHITECTUREINVOICE,
    DELETE_ARCHITECTUREINVOICE,
} from "./type";
import ARCInvoice from "../service/arcInvoice";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCInvoice.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCInvoice.create(data);
        dispatch({
            type: CREATE_ARCHITECTUREINVOICE,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCInvoice.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTUREINVOICE,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCInvoice.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTUREINVOICE,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCInvoice.update(data);
        dispatch({
            type: UPDATE_ARCHITECTUREINVOICE,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCInvoice.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTUREINVOICE,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCInvoice.trash(data);
        dispatch({
            type: DELETE_ARCHITECTUREINVOICE,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};